<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  @if (showTrack()) {
    <circle class="track"/>
  }
  <circle class="spinner"/>
</svg>